import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-twitter",
  "use": "icon-twitter-usage",
  "viewBox": "0 0 12 12",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 12\" fill=\"none\" id=\"icon-twitter\">\n  <path d=\"M6.85959 5.30969L10.2094 1.49951H9.41573L6.50575 4.80715L4.18325 1.49951H1.50391L5.01677 6.50169L1.50391 10.4969H2.29761L5.36873 7.00311L7.82195 10.4969H10.5013L6.85959 5.30969ZM5.77215 6.5456L5.41568 6.04719L2.58383 2.085H3.80312L6.08918 5.2838L6.44415 5.78221L9.41536 9.93994H8.19607L5.77215 6.5456Z\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol